import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.checkliste-aufgabe';
import * as api from '../../../clients/vorlagen';

@Injectable()
export class VorlagenChecklisteAufgabeEffects {

    ChecklisteAufgabe$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_CHECKLISTE_AUFGABE),
        mergeMap((x: ac.GetChecklisteAufgabeAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getChecklisteAufgabe(x.checkliste_id, x.aufgabe_id).pipe(
                map((result: any) => {
                    return new ac.GetChecklisteAufgabeErfolgreichAction(result, x.checkliste_id, x.aufgabe_id, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetChecklisteAufgabeFehlerAction(error, x.checkliste_id, x.aufgabe_id, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.ChecklisteQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.ChecklisteQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.ChecklisteQueryService);
        }
        return this.service;
    }
}
